import React from "react";
import "./portfolio.css";
import BillingManagement from "../../assets/billingManagement.png";
import BimalTv from "../../assets/bimalTv.png";
import BistaAayush from "../../assets/bistaaayush.png";
import AppSkill from "../../assets/appskill.png";
import CodeQuant from "../../assets/codequant.png";
import DrinksraMart from "../../assets/drinksramart.png";
import FirmZilla from "../../assets/firmzilla.png";
import RojgarBikash from "../../assets/rojgarbikash.png";
import WellGrowing from "../../assets/well growing.png";
const index = () => {
  return (
    <div className="portfolioContainer">
      <h2 className="portfolioHeading">Portfolio</h2>
      <div className="titleUnderline"></div>
      <h1 className="portfolioHeading2">My Works</h1>
      <div className="portfolioItems">
        <div className="portfolioItem">
          <a href="http://appskill.com.au/" alt="images">
            <img src={AppSkill} alt="Recruitment Agency" />
            <div className="texts">
              APPSKILL || Recruitment Agency
            </div>
          </a>
        </div>
        <div className="portfolioItem">
          <a href="https://bimaltv.com/" alt="images">
            <img src={BimalTv} alt="Portfolio Website" />
            <div className="texts">
              Bimal TV || Portfolio
            </div>
          </a>
        </div>
        <div className="portfolioItem">
          <a href="https://bistaaayush.com.np/" alt="images">
            <img src={BistaAayush} alt="Portfolio" />
            <div className="texts">
              Bista Aayush|| Portfolio
            </div>
          </a>
        </div>
        <div className="portfolioItem">
          <a href="https://wellgrowingrecruitment.com.np/" alt="images">
            <img src={WellGrowing} alt="Recruitment Agency" />
            <div className="texts">
              Well Growing || Recruitment Agency
            </div>
          </a>
        </div>
        <div className="portfolioItem">
          <a href="https://github.com/nikeshpyakurel" alt="images">
            <img src={BillingManagement} alt="Billing Management Sytem" />
             <div className="texts">
              Digital Inventory || Inventory Management
            </div>
          </a>
        </div>
        <div className="portfolioItem">
          <a href="https://codequant.io/" alt="images">
            <img src={CodeQuant} alt="Blog Website" />
            <div className="texts">
              CodeQuant || Coorporate Website
            </div>
          </a>
        </div>
        <div className="portfolioItem">
        <a href="https://www.firmzilla.co.uk/" alt="images">
            <img src={FirmZilla} alt="Business Registration" />
            <div className="texts">
              FirmZilla || Business Registration
            </div>
        </a>
        </div>
        <div className="portfolioItem">
          <a href="https://drinksramart.com/" alt="images">

            <img src={DrinksraMart} alt="Ecommerce" />
            <div className="texts">
              DrinksRaMart || Ecommerce
            </div>
          </a>
        </div>
        <div className="portfolioItem">
          <a href="https://rojgarbikash.com/" alt="images">
            <img src={RojgarBikash} alt="News Portal" />
            <div className="texts">
              Rojgar Bikash || News Portal 
            </div>
          </a>
        </div>
      </div>
      <button className="portfolioBtn">
        <a href="#contact" alt="button">Hire Me </a>
      </button>
    </div>
  );
};

export default index;
